module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.feature.options), function(option) {
    return _c('v-touch', {
      key: option.name,
      staticClass: "dib pointer m1r",
      class: {
        'white': option === _vm.feature.active
      },
      on: {
        "tap": function($event) {
          _vm.changeOption(option)
        }
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.changeOption(option)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86958512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceFeatures.vue
// module id = 153
// module chunks = 0